
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/component/mobileSlider",
      function () {
        return require("private-next-pages/home/component/mobileSlider/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/component/mobileSlider"])
      });
    }
  